import React from 'react';
import xCircle from "../../../styles/icons/x-circle.svg";
import checkCircle from "../../../styles/icons/check-circle.svg";

class ModalMensajePersonalizado extends React.Component {
  constructor(props) {
    super(props);
    this.dialogRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.abrirModal();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        this.abrirModal();
      } else {
        this.cerrarModalConAnimacion();
      }
    }
  }

  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
      this.dialogRef.current.style.scale = '1';
    }
  };

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
    }
  };

  cerrarModalConAnimacion = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.style.scale = '0';
      setTimeout(() => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
          this.dialogRef.current.close();
        }
      }, 300);
    }
  };

  manejarAceptar = () => {
    this.cerrarModalConAnimacion();
    setTimeout(() => {
      this.props.onClose?.();
    }, 300);
  };

  render() {
    const { error, msg, isOpen } = this.props;

    if (!isOpen) return null;

    return (
      <div className="component-modal">
        <dialog
          className="modal"
          ref={this.dialogRef}
          onClose={this.manejarAceptar}
          style={{
            transition: 'scale 0.3s ease',
            scale: 1,
          }}
        >
          <div className="modal-content">
            <div className="modal-body">
              <div className="label__danger-icon">
                Error
              </div>
              <h4 className="title"> Ha ocurrido un error </h4>
              <p className="msg"> {msg} </p>
            </div>
            <button className="link-default" onClick={this.props.accion}>
              Cerrar
            </button>
          </div>
        </dialog>
      </div>
    );
  }
}

export default ModalMensajePersonalizado;
